/* eslint-disable no-param-reassign */
import React from 'react';
import PropTypes from 'prop-types';

function PanelBody({
  children,
  activeTab = 0,
  noCard = false,
  className = '',
  onTab = null,
}) {
  children = Array.isArray(children) ? children.flat(1) : children;
  if (children?.type === React.Fragment) {
    const { children: fragmentChildren } = children.props;
    children = fragmentChildren;
  }
  if (React.isValidElement(children)) {
    children = [children];
  }

  const handleArrayChildren = () => {
    const filteredChildren = children.filter((child, i) => child && !(child?.type?.displayName === 'PanelTab' && ![child.key, i].includes(activeTab)));

    if (!filteredChildren.length && activeTab !== 0) {
      onTab(0);
    }

    return filteredChildren;
  };

  return (
    <div className={`panel-body simple-scrollbar ${className} ${noCard ? 'noCard' : ''}`}>
      { Array.isArray(children) ? handleArrayChildren() : children }
    </div>
  );
}

PanelBody.displayName = 'PanelBody';

PanelBody.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  activeTab: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  noCard: PropTypes.bool,
  className: PropTypes.string,
  onTab: PropTypes.func,
};

PanelBody.defaultProps = {
  activeTab: 0,
  noCard: false,
  className: '',
  onTab: null,
};

export default PanelBody;
